import {Box, Button, Typography} from "@mui/material";
import { useState } from "react";
import UploadDropzone from "../../components/custom/uploadFiles/uploadDropzone";
import UploadedFilesTable from "../../components/custom/uploadFiles/uploadedFilesTable";
import {useTranslation} from "react-i18next";
import {PAGE_APPLICATIONS} from "../../locales/pages/namespaces";
import PageHeader from "../../components/custom/layout/pageHeader";
import PageContainer from "../../components/custom/layout/pageContainer";
import {getRouteUrl} from "../../helpers/routing/getRouteUrl";
import {ROUTE_PAGE_HOME} from "../../routers/routes";
import {useParams} from "react-router";
import {useHistory} from "react-router-dom";
import axios from "axios";
import {getEndPoint} from "../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../helpers/errorHandling";
import {useUser} from "../../userContext/userContext";
import {fileToBase64} from "../../helpers/fileToBase64";
import dayjs from "dayjs";


const UploadPage = () => {
    const {campaign} = useParams()
    const {verificationId,reqId} = useUser()
    const history = useHistory()
    const [files, setFiles] = useState([]);
    const { t } = useTranslation(PAGE_APPLICATIONS);
    const handleBack = () => {
            history.push(getRouteUrl(ROUTE_PAGE_HOME,{campaign}))
    };
    const handleDeleteFile = (index) => {
        setFiles(prev => prev.filter((_, i) => i !== index));
    };

    const onSendFile = async (file) => {
        try {
            const base64 = file.base64
                ? file.base64
                : await fileToBase64(file);

            const payload = {
                request_id: reqId,
                filename: file.name,
                filetype: file.name.split(".").pop(),
                base64,
                category: "Request File",
                docdate: dayjs().format("MM/DD/YYYY"),
            };

            await axios({
                method: "post",
                url: getEndPoint("requestDocuments"),
                data: payload,
                headers: { "Content-Type": "application/json" },
            });

            enqueueSnackbar(t("File sent!"), {
                variant: "success",
            });
            history.push(getRouteUrl(ROUTE_PAGE_HOME, { campaign }));

        } catch (error) {
            enqueueSnackbar(t('Failed to sent the file'), {
                variant: "error",
            });
        }
    };


    return (
        <PageContainer>
            <PageHeader
                isUpload = {true}
            />
        <Box maxWidth={900} mx="auto" mt={6}>
            <Typography variant="h6" mb={3}>
                {t('File upload')}
            </Typography>

            <UploadDropzone
                onFilesAdded={(newFiles) =>
                    setFiles((prev) => [...prev, ...newFiles])
                }
            />

            <UploadedFilesTable files={files} onDelete={handleDeleteFile} onSend={onSendFile} />
        </Box>
            <Box sx={{ mt: 6, display: "flex", gap: 2 }}>
                <Button
                    variant="contained"
                    sx={{ bgcolor: "#004B88",color:"#fff" }}
                    onClick={handleBack}
                >
                    {t("Back")}
                </Button>

            </Box>
        </PageContainer>
    );
};

export default UploadPage;
